"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountPropertySelector = createAmountPropertySelector;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const QuantityConverison = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const Contexts = __importStar(require("../contexts"));
const quantity_selector_1 = require("./quantity-selector");
const ErrorBox = styled_components_1.default.div `
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  margin-left: 5px;
  max-width: 200px;
  background: #dc000c;
  padding: 8px;
  border-radius: 2px;
  color: #fff;
  white-space: pre-wrap;
  font-size: 12px;
  box-shadow: 1px 1px 5px #8a8a8a;
`;
const ErrorBoxWrapper = styled_components_1.default.div `
  width: 200px;
`;
const ErrorBoxContainer = styled_components_1.default.div `
  position: absolute;
  left: 100%;
`;
function createAmountPropertySelector({ AmountFormatSelector, AmountInputBox }) {
    return class AmountPropertySelector extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                hasFocus: false
            };
        }
        render() {
            return (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ activatedQuantitySelectors, conversionParametersMap, fieldGroup, getAmountFormat, onQuantityChange, fieldNameMap }) => {
                const { onValueChange, onFormatChanged, onFormatCleared, onFormatSelectorToggled, notNumericMessage, isRequiredMessage, validationFilter, propertyValueSet, propertyName, filterPrettyPrint, inputUnit, readOnly, debounceTime = 700 } = this.props;
                const nonConvertedValue = property_1.PropertyValueSet.getAmount(propertyName, propertyValueSet);
                const amountFormat = getAmountFormat(fieldGroup, fieldNameMap[propertyName], inputUnit.quantity);
                const conversionParameters = conversionParametersMap[propertyName];
                const validationMessage = [
                    humidityValidationMessage(humidityValidation(conversionParameters, nonConvertedValue)),
                    getValidationMessage(propertyValueSet, nonConvertedValue, validationFilter, filterPrettyPrint)
                ].reduce((a, b) => (a ? a : b), "");
                return (React.createElement("div", { style: { display: "inline-block", position: "relative" } },
                    React.createElement(AmountInputBox, { value: getMaybeConvertedValue(conversionParameters, amountFormat, nonConvertedValue), inputUnit: amountFormat.unit, inputDecimalCount: amountFormat.decimalCount, notNumericMessage: notNumericMessage, isRequiredMessage: isRequiredMessage, errorMessage: validationMessage, readOnly: readOnly, onValueChange: newAmount => {
                            if (newAmount === undefined) {
                                return onValueChange(undefined);
                            }
                            const maybeConverted = getMaybeConvertedBackValue(conversionParameters, newAmount, inputUnit.quantity);
                            onValueChange(property_1.PropertyValue.fromAmount(maybeConverted));
                        }, debounceTime: debounceTime, onBlur: () => {
                            this.setState({
                                hasFocus: false
                            });
                        }, onFocus: () => {
                            this.setState({
                                hasFocus: true
                            });
                        } }),
                    React.createElement(AmountFormatSelector, { selectedUnit: amountFormat.unit, selectedDecimalCount: amountFormat.decimalCount, userSelected: amountFormat.userDefined, onFormatChanged: onFormatChanged, onFormatCleared: onFormatCleared, onFormatSelectorActiveChanged: onFormatSelectorToggled, unitsFormat: uom_1.UnitsFormat }),
                    React.createElement(quantity_selector_1.QuantitySelector, { conversionParameters: conversionParameters, isQuantitySelectorActive: activatedQuantitySelectors[propertyName], onQuantityChange: quantity => {
                            onQuantityChange(propertyName, quantity);
                        }, quantity: amountFormat.unit.quantity }),
                    validationMessage && this.state.hasFocus && (React.createElement(ErrorBoxContainer, null,
                        React.createElement(ErrorBoxWrapper, null,
                            React.createElement(ErrorBox, null, validationMessage.trim()))))));
            }));
        }
    };
}
function getMaybeConvertedValue(conversionParameters, amountFormat, nonConvertedValue) {
    if (nonConvertedValue === undefined) {
        return nonConvertedValue;
    }
    if (conversionParameters === undefined) {
        return nonConvertedValue;
    }
    if (amountFormat.unit.quantity === nonConvertedValue.unit.quantity) {
        return nonConvertedValue;
    }
    const convertedValue = QuantityConverison.convertQuantity(nonConvertedValue, amountFormat.unit.quantity, conversionParameters);
    return convertedValue;
}
function getMaybeConvertedBackValue(conversionParameters, maybeConvertedValue, expectedQuantity) {
    if (maybeConvertedValue === undefined) {
        return maybeConvertedValue;
    }
    if (conversionParameters === undefined) {
        return maybeConvertedValue;
    }
    if (expectedQuantity === maybeConvertedValue.unit.quantity) {
        return maybeConvertedValue;
    }
    const convertedValue = QuantityConverison.convertQuantity(maybeConvertedValue, expectedQuantity, conversionParameters);
    return convertedValue;
}
function humidityValidationMessage(hum) {
    if (!hum) {
        return "";
    }
    return "Invalid humidity";
}
function humidityValidation(conversionParameters, value) {
    if (!conversionParameters || !value) {
        return undefined;
    }
    const relativeHum = value.unit.quantity === "RelativeHumidity"
        ? value
        : QuantityConverison.convertQuantity(value, "RelativeHumidity", conversionParameters);
    return uom_1.Amount.greaterThan(relativeHum, uom_1.Amount.create(0.9995, uom_1.Units.HumidityFactor))
        ? relativeHum
        : undefined;
}
function getValidationMessage(propertyValueSet, value, validationFilter, filterPrettyPrint) {
    if (!value || !validationFilter) {
        return "";
    }
    if (property_1.PropertyFilter.isValid(propertyValueSet, validationFilter)) {
        return "";
    }
    else {
        return filterPrettyPrint(validationFilter);
    }
}
//# sourceMappingURL=amount-property-selector.js.map